export const PRIMARY_LABEL = "PRIMARY_LABEL";
export const SECONDARY_LABEL = "SECONDARY_LABEL";

export const LABEL_TYPES = [PRIMARY_LABEL, SECONDARY_LABEL];
